import React from 'react';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';
import Select from 'react-select';

import ThirdPartyAPI from '../../../api/ThirdPartyAPI';
import withRouter from '../../../util/WithRouter';
import WhatsAppConst from '../../../util/WhatsAppConst';
import Const from '../../../util/Constants';
import ApiUiController from '../../../controller/ApiUiController';
import Util from '../../../util/Util';
import RegEx from '../../../util/RegEx';

class WhatsAppUpdate extends React.Component {

  constructor(props) {
    super(props);
    const id = parseInt(props.match.params.id);
    this.state = { inApiCall: id !== 0, id: id, name: '', type: 0, auth: '', assigments: '', inValid: {} };
    this.basePath = this.props.match.path;
    this.basePath = this.basePath.substring(0, this.basePath.indexOf('/add-edit'));
  }

  componentDidMount() {
    if (this.state.id !== 0) {
      ThirdPartyAPI.get(this.state.id, this.onReceived, this.onFail);
    }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onReceived = api => {
    const type = WhatsAppConst.Options.find(item => item.value === api.type);
    this.setState({
      ...this.state, inApiCall: false, id: api.id, name: api.name, type, auth: api.api_data,
      assigments: api.assigments ? api.assigments : ''
    });
  };

  keyChange = (key, event) => {
    const state = { ...this.state };
    state[key] = event.target.value;
    this.setState({ ...this.state, ...state });
  };
  methodChange = tog => this.setState({ ...this.state, method: tog ? Const.True : Const.False });

  onSave = () => {
    let inValid = {};
    if (this.state.name.trim() === '') inValid = { ...inValid, name: 'Invalid Field' };
    if (!this.state.type) inValid = { ...inValid, type: 'Invalid Field' };
    if (this.state.auth.length === 0) inValid = { ...inValid, auth: 'Invalid Field' };

    if (Object.keys(inValid).length === 0) {
      this.setState({ ...this.state, inApiCall: true });
      const api = {
        id: this.state.id, name: this.state.name, type: this.state.type.value,
        model_no: Const.WhatsApp, party_type: Const.WhatsApp, api_data: this.state.auth,
        assigments: this.state.assigments, method: 1
      };
      ThirdPartyAPI.save(api, this.onSaved, this.onFail);
    } else {
      Util.showNotification('Form incomplete', 'Please fill all information', 'danger');
      this.setState({ ...this.state, inValid: { ...inValid } });
    }
  };
  onSaved = () => {
    Util.showNotification('Successful', 'Successfully saved.', 'success');
    this.props.navigate(this.basePath);
  };

  render() {
    const inValid = this.state.inValid;

    return (
      <div className="sectionform pt-4 ">
        <div className="container form-cont">
          <div className="row">
            <div className="col-md-12 pb-4"><h3>WhatsApp {this.state.id ? 'Update' : 'Add'}</h3></div>
          </div>

          <ApiUiController inApiCall={this.props.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              <div className="col-md-4">
                <div className="form-group">
                  <FormControl type='text' placeholder='Name'
                    className={`mr-sm-2 ${RegEx.class(inValid, 'name')}`}
                    value={this.state.name} onChange={evt => this.keyChange('name', evt)} />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <Select value={this.state.type} options={WhatsAppConst.Options} isSearchable={false} isClearable={true}
                    onChange={type => this.setState({ ...this.state, type })} />
                </div>
              </div>

              <div className="col-md-12">
                <div className="form-group">
                  <FormControl type='text' placeholder='Authorization Key'
                    className={`mr-sm-2 ${RegEx.class(inValid, 'auth')}`}
                    value={this.state.auth} onChange={evt => this.keyChange('auth', evt)} />
                </div>
              </div>

              <div className="col-md-12">
                <div className="form-group">
                  <FormControl type='text' placeholder='URL if required'
                    value={this.state.assigments} onChange={evt => this.keyChange('assigments', evt)} />
                </div>
              </div>

              <div className="col-md-12 text-center btnsend">
                <Button variant="success" onClick={this.onSave}>Save</Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(WhatsAppUpdate);